<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in task priority here"
                  append-icon="search"
                  label="Search task priority"
                  hide-no-data
                  hide-selected
                  clearable
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Task Priority's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-tasks-priorities-dialog-create
                  @created="loadTaskPriorities"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :loading="tableLoading"
            :headers="headers"
            :items="filteredTaskPriorities"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <span v-if="statusFilter">
                <setup-tasks-priorities-dialog-edit
                  :task-priority="item"
                  @updated="loadTaskPriorities"
                />
                <span class="mx-1" />
                <setup-tasks-priorities-dialog-delete
                  :task-priority="item"
                  @deleted="loadTaskPriorities"
                />
              </span>
              <span v-else>
                <setup-tasks-priorities-dialog-restore
                  :task-priority="item"
                  @restored="loadTaskPriorities"
                />
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupTasksPrioritiesDialogCreate: () => import('@/components/setup/tasks/priorities/DialogCreate'),
      SetupTasksPrioritiesDialogEdit: () => import('@/components/setup/tasks/priorities/DialogEdit'),
      SetupTasksPrioritiesDialogDelete: () => import('@/components/setup/tasks/priorities/DialogDelete'),
      SetupTasksPrioritiesDialogRestore: () => import('@/components/setup/tasks/priorities/DialogRestore'),
    },
    metaInfo () {
      return {
        title: 'Task Priorities',
      }
    },
    data () {
      return {
        taskPriorities: [],
        trashedTaskPriorities: [],
        search: '',
        tableLoading: true,
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        headers: [
          {
            text: 'Task Priority',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],
      }
    },
    computed: {
      filteredTaskPriorities () {
        return this.statusFilter ? this.taskPriorities : this.trashedTaskPriorities
      },
    },
    created () {
      this.loadTaskPriorities()
    },
    methods: {
      loadTaskPriorities () {
        this.tableLoading = true

        Promise.all([
          this.$api.taskPriorities().list(),
          this.$api.taskPriorities().listTrashed(),
        ])
          .then(([taskPriorities, trashedTaskPriorities]) => {
            this.taskPriorities = taskPriorities.data
            this.trashedTaskPriorities = trashedTaskPriorities.data
            this.tableLoading = false
          })
      },
    },
  }
</script>
